import {
  Alert,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { ReactNode, useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import useSound from "use-sound";

export const RecapCard = ({
  subject,
}: {
  subject: {
    label: string;
    image?: string;
    main?: string | ReactNode;
    reveal?: string | ReactNode;
  };
}) => {
  const [revealed, setRevealed] = useState(false);
  const theme = useTheme();

  const [playCorrect] = useSound("/sound/correct.wav");

  const handleReveal = () => {
    const nextState = !revealed;
    setRevealed(nextState);

    if (nextState) {
      playCorrect();
    }
  };

  return (
    <Card sx={{ backgroundColor: "rgb(0 255 163 / 0.1)" }}>
      <CardContent>
        <Typography variant="h5">{subject.label}</Typography>
      </CardContent>

      {subject?.image && (
        <Box sx={{ p: 2 }}>
          <CardMedia
            component="img"
            image={subject.image}
            sx={{ borderRadius: theme.shape.borderRadius }}
          />
        </Box>
      )}

      {subject?.main && (
        <Box p={2} minHeight={100}>
          <Typography variant="body2" sx={{ fontSize: "20px" }}>
            {subject.main}
          </Typography>
        </Box>
      )}

      {revealed && (
        <CardContent>
          <Alert severity="success" sx={{ alignItems: "center" }}>
            <Typography variant="h6">
              {/* We controleren of het een string is voor de Typography, anders renderen we de node direct */}
              {typeof subject.reveal === "string" ? (
                <Typography variant="h6">{subject.reveal}</Typography>
              ) : (
                <Box sx={{ width: "100%" }}>{subject.reveal}</Box>
              )}
            </Typography>
          </Alert>
        </CardContent>
      )}

      {subject?.reveal && (
        <IconButton onClick={handleReveal}>
          <VisibilityIcon />
        </IconButton>
      )}
    </Card>
  );
};
